/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as IndexRouteImport } from "./routes/index"
import { Route as TermsIndexRouteImport } from "./routes/terms.index"
import { Route as SitemapIndexRouteImport } from "./routes/sitemap.index"
import { Route as SignupIndexRouteImport } from "./routes/signup.index"
import { Route as PrivacyPolicyIndexRouteImport } from "./routes/privacy-policy.index"
import { Route as LoginIndexRouteImport } from "./routes/login.index"
import { Route as LocationIndexRouteImport } from "./routes/location.index"
import { Route as DisclaimerIndexRouteImport } from "./routes/disclaimer.index"
import { Route as CookiesPolicyIndexRouteImport } from "./routes/cookies-policy.index"
import { Route as ContactIndexRouteImport } from "./routes/contact.index"
import { Route as CategoryIndexRouteImport } from "./routes/category.index"
import { Route as BlogIndexRouteImport } from "./routes/blog.index"
import { Route as AddBusinessIndexRouteImport } from "./routes/add-business.index"
import { Route as AboutIndexRouteImport } from "./routes/about.index"
import { Route as ListingIdSlugRouteImport } from "./routes/listing.$idSlug"
import { Route as LocationSlugIndexRouteImport } from "./routes/location.$slug.index"
import { Route as CategorySlugIndexRouteImport } from "./routes/category.$slug.index"
import { Route as BlogSlugIndexRouteImport } from "./routes/blog.$slug.index"
import { Route as LocationLocCatIndexRouteImport } from "./routes/location.$loc.$cat.index"

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any)
const TermsIndexRoute = TermsIndexRouteImport.update({
  id: "/terms/",
  path: "/terms/",
  getParentRoute: () => rootRouteImport,
} as any)
const SitemapIndexRoute = SitemapIndexRouteImport.update({
  id: "/sitemap/",
  path: "/sitemap/",
  getParentRoute: () => rootRouteImport,
} as any)
const SignupIndexRoute = SignupIndexRouteImport.update({
  id: "/signup/",
  path: "/signup/",
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyPolicyIndexRoute = PrivacyPolicyIndexRouteImport.update({
  id: "/privacy-policy/",
  path: "/privacy-policy/",
  getParentRoute: () => rootRouteImport,
} as any)
const LoginIndexRoute = LoginIndexRouteImport.update({
  id: "/login/",
  path: "/login/",
  getParentRoute: () => rootRouteImport,
} as any)
const LocationIndexRoute = LocationIndexRouteImport.update({
  id: "/location/",
  path: "/location/",
  getParentRoute: () => rootRouteImport,
} as any)
const DisclaimerIndexRoute = DisclaimerIndexRouteImport.update({
  id: "/disclaimer/",
  path: "/disclaimer/",
  getParentRoute: () => rootRouteImport,
} as any)
const CookiesPolicyIndexRoute = CookiesPolicyIndexRouteImport.update({
  id: "/cookies-policy/",
  path: "/cookies-policy/",
  getParentRoute: () => rootRouteImport,
} as any)
const ContactIndexRoute = ContactIndexRouteImport.update({
  id: "/contact/",
  path: "/contact/",
  getParentRoute: () => rootRouteImport,
} as any)
const CategoryIndexRoute = CategoryIndexRouteImport.update({
  id: "/category/",
  path: "/category/",
  getParentRoute: () => rootRouteImport,
} as any)
const BlogIndexRoute = BlogIndexRouteImport.update({
  id: "/blog/",
  path: "/blog/",
  getParentRoute: () => rootRouteImport,
} as any)
const AddBusinessIndexRoute = AddBusinessIndexRouteImport.update({
  id: "/add-business/",
  path: "/add-business/",
  getParentRoute: () => rootRouteImport,
} as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: "/about/",
  path: "/about/",
  getParentRoute: () => rootRouteImport,
} as any)
const ListingIdSlugRoute = ListingIdSlugRouteImport.update({
  id: "/listing/$idSlug",
  path: "/listing/$idSlug",
  getParentRoute: () => rootRouteImport,
} as any)
const LocationSlugIndexRoute = LocationSlugIndexRouteImport.update({
  id: "/location/$slug/",
  path: "/location/$slug/",
  getParentRoute: () => rootRouteImport,
} as any)
const CategorySlugIndexRoute = CategorySlugIndexRouteImport.update({
  id: "/category/$slug/",
  path: "/category/$slug/",
  getParentRoute: () => rootRouteImport,
} as any)
const BlogSlugIndexRoute = BlogSlugIndexRouteImport.update({
  id: "/blog/$slug/",
  path: "/blog/$slug/",
  getParentRoute: () => rootRouteImport,
} as any)
const LocationLocCatIndexRoute = LocationLocCatIndexRouteImport.update({
  id: "/location/$loc/$cat/",
  path: "/location/$loc/$cat/",
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute
  "/listing/$idSlug": typeof ListingIdSlugRoute
  "/about/": typeof AboutIndexRoute
  "/add-business/": typeof AddBusinessIndexRoute
  "/blog/": typeof BlogIndexRoute
  "/category/": typeof CategoryIndexRoute
  "/contact/": typeof ContactIndexRoute
  "/cookies-policy/": typeof CookiesPolicyIndexRoute
  "/disclaimer/": typeof DisclaimerIndexRoute
  "/location/": typeof LocationIndexRoute
  "/login/": typeof LoginIndexRoute
  "/privacy-policy/": typeof PrivacyPolicyIndexRoute
  "/signup/": typeof SignupIndexRoute
  "/sitemap/": typeof SitemapIndexRoute
  "/terms/": typeof TermsIndexRoute
  "/blog/$slug/": typeof BlogSlugIndexRoute
  "/category/$slug/": typeof CategorySlugIndexRoute
  "/location/$slug/": typeof LocationSlugIndexRoute
  "/location/$loc/$cat/": typeof LocationLocCatIndexRoute
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute
  "/listing/$idSlug": typeof ListingIdSlugRoute
  "/about": typeof AboutIndexRoute
  "/add-business": typeof AddBusinessIndexRoute
  "/blog": typeof BlogIndexRoute
  "/category": typeof CategoryIndexRoute
  "/contact": typeof ContactIndexRoute
  "/cookies-policy": typeof CookiesPolicyIndexRoute
  "/disclaimer": typeof DisclaimerIndexRoute
  "/location": typeof LocationIndexRoute
  "/login": typeof LoginIndexRoute
  "/privacy-policy": typeof PrivacyPolicyIndexRoute
  "/signup": typeof SignupIndexRoute
  "/sitemap": typeof SitemapIndexRoute
  "/terms": typeof TermsIndexRoute
  "/blog/$slug": typeof BlogSlugIndexRoute
  "/category/$slug": typeof CategorySlugIndexRoute
  "/location/$slug": typeof LocationSlugIndexRoute
  "/location/$loc/$cat": typeof LocationLocCatIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/": typeof IndexRoute
  "/listing/$idSlug": typeof ListingIdSlugRoute
  "/about/": typeof AboutIndexRoute
  "/add-business/": typeof AddBusinessIndexRoute
  "/blog/": typeof BlogIndexRoute
  "/category/": typeof CategoryIndexRoute
  "/contact/": typeof ContactIndexRoute
  "/cookies-policy/": typeof CookiesPolicyIndexRoute
  "/disclaimer/": typeof DisclaimerIndexRoute
  "/location/": typeof LocationIndexRoute
  "/login/": typeof LoginIndexRoute
  "/privacy-policy/": typeof PrivacyPolicyIndexRoute
  "/signup/": typeof SignupIndexRoute
  "/sitemap/": typeof SitemapIndexRoute
  "/terms/": typeof TermsIndexRoute
  "/blog/$slug/": typeof BlogSlugIndexRoute
  "/category/$slug/": typeof CategorySlugIndexRoute
  "/location/$slug/": typeof LocationSlugIndexRoute
  "/location/$loc/$cat/": typeof LocationLocCatIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | "/"
    | "/listing/$idSlug"
    | "/about/"
    | "/add-business/"
    | "/blog/"
    | "/category/"
    | "/contact/"
    | "/cookies-policy/"
    | "/disclaimer/"
    | "/location/"
    | "/login/"
    | "/privacy-policy/"
    | "/signup/"
    | "/sitemap/"
    | "/terms/"
    | "/blog/$slug/"
    | "/category/$slug/"
    | "/location/$slug/"
    | "/location/$loc/$cat/"
  fileRoutesByTo: FileRoutesByTo
  to:
    | "/"
    | "/listing/$idSlug"
    | "/about"
    | "/add-business"
    | "/blog"
    | "/category"
    | "/contact"
    | "/cookies-policy"
    | "/disclaimer"
    | "/location"
    | "/login"
    | "/privacy-policy"
    | "/signup"
    | "/sitemap"
    | "/terms"
    | "/blog/$slug"
    | "/category/$slug"
    | "/location/$slug"
    | "/location/$loc/$cat"
  id:
    | "__root__"
    | "/"
    | "/listing/$idSlug"
    | "/about/"
    | "/add-business/"
    | "/blog/"
    | "/category/"
    | "/contact/"
    | "/cookies-policy/"
    | "/disclaimer/"
    | "/location/"
    | "/login/"
    | "/privacy-policy/"
    | "/signup/"
    | "/sitemap/"
    | "/terms/"
    | "/blog/$slug/"
    | "/category/$slug/"
    | "/location/$slug/"
    | "/location/$loc/$cat/"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ListingIdSlugRoute: typeof ListingIdSlugRoute
  AboutIndexRoute: typeof AboutIndexRoute
  AddBusinessIndexRoute: typeof AddBusinessIndexRoute
  BlogIndexRoute: typeof BlogIndexRoute
  CategoryIndexRoute: typeof CategoryIndexRoute
  ContactIndexRoute: typeof ContactIndexRoute
  CookiesPolicyIndexRoute: typeof CookiesPolicyIndexRoute
  DisclaimerIndexRoute: typeof DisclaimerIndexRoute
  LocationIndexRoute: typeof LocationIndexRoute
  LoginIndexRoute: typeof LoginIndexRoute
  PrivacyPolicyIndexRoute: typeof PrivacyPolicyIndexRoute
  SignupIndexRoute: typeof SignupIndexRoute
  SitemapIndexRoute: typeof SitemapIndexRoute
  TermsIndexRoute: typeof TermsIndexRoute
  BlogSlugIndexRoute: typeof BlogSlugIndexRoute
  CategorySlugIndexRoute: typeof CategorySlugIndexRoute
  LocationSlugIndexRoute: typeof LocationSlugIndexRoute
  LocationLocCatIndexRoute: typeof LocationLocCatIndexRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/terms/": {
      id: "/terms/"
      path: "/terms"
      fullPath: "/terms/"
      preLoaderRoute: typeof TermsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/sitemap/": {
      id: "/sitemap/"
      path: "/sitemap"
      fullPath: "/sitemap/"
      preLoaderRoute: typeof SitemapIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/signup/": {
      id: "/signup/"
      path: "/signup"
      fullPath: "/signup/"
      preLoaderRoute: typeof SignupIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/privacy-policy/": {
      id: "/privacy-policy/"
      path: "/privacy-policy"
      fullPath: "/privacy-policy/"
      preLoaderRoute: typeof PrivacyPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/login/": {
      id: "/login/"
      path: "/login"
      fullPath: "/login/"
      preLoaderRoute: typeof LoginIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/location/": {
      id: "/location/"
      path: "/location"
      fullPath: "/location/"
      preLoaderRoute: typeof LocationIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/disclaimer/": {
      id: "/disclaimer/"
      path: "/disclaimer"
      fullPath: "/disclaimer/"
      preLoaderRoute: typeof DisclaimerIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/cookies-policy/": {
      id: "/cookies-policy/"
      path: "/cookies-policy"
      fullPath: "/cookies-policy/"
      preLoaderRoute: typeof CookiesPolicyIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/contact/": {
      id: "/contact/"
      path: "/contact"
      fullPath: "/contact/"
      preLoaderRoute: typeof ContactIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/category/": {
      id: "/category/"
      path: "/category"
      fullPath: "/category/"
      preLoaderRoute: typeof CategoryIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/blog/": {
      id: "/blog/"
      path: "/blog"
      fullPath: "/blog/"
      preLoaderRoute: typeof BlogIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/add-business/": {
      id: "/add-business/"
      path: "/add-business"
      fullPath: "/add-business/"
      preLoaderRoute: typeof AddBusinessIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/about/": {
      id: "/about/"
      path: "/about"
      fullPath: "/about/"
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/listing/$idSlug": {
      id: "/listing/$idSlug"
      path: "/listing/$idSlug"
      fullPath: "/listing/$idSlug"
      preLoaderRoute: typeof ListingIdSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/location/$slug/": {
      id: "/location/$slug/"
      path: "/location/$slug"
      fullPath: "/location/$slug/"
      preLoaderRoute: typeof LocationSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/category/$slug/": {
      id: "/category/$slug/"
      path: "/category/$slug"
      fullPath: "/category/$slug/"
      preLoaderRoute: typeof CategorySlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/blog/$slug/": {
      id: "/blog/$slug/"
      path: "/blog/$slug"
      fullPath: "/blog/$slug/"
      preLoaderRoute: typeof BlogSlugIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/location/$loc/$cat/": {
      id: "/location/$loc/$cat/"
      path: "/location/$loc/$cat"
      fullPath: "/location/$loc/$cat/"
      preLoaderRoute: typeof LocationLocCatIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ListingIdSlugRoute: ListingIdSlugRoute,
  AboutIndexRoute: AboutIndexRoute,
  AddBusinessIndexRoute: AddBusinessIndexRoute,
  BlogIndexRoute: BlogIndexRoute,
  CategoryIndexRoute: CategoryIndexRoute,
  ContactIndexRoute: ContactIndexRoute,
  CookiesPolicyIndexRoute: CookiesPolicyIndexRoute,
  DisclaimerIndexRoute: DisclaimerIndexRoute,
  LocationIndexRoute: LocationIndexRoute,
  LoginIndexRoute: LoginIndexRoute,
  PrivacyPolicyIndexRoute: PrivacyPolicyIndexRoute,
  SignupIndexRoute: SignupIndexRoute,
  SitemapIndexRoute: SitemapIndexRoute,
  TermsIndexRoute: TermsIndexRoute,
  BlogSlugIndexRoute: BlogSlugIndexRoute,
  CategorySlugIndexRoute: CategorySlugIndexRoute,
  LocationSlugIndexRoute: LocationSlugIndexRoute,
  LocationLocCatIndexRoute: LocationLocCatIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
